export const UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT_FAILURE';

export const uploadDocumentFailure = error => ({
    type: UPLOAD_DOCUMENT_FAILURE,
    payload: error,
    error: true,
});
